import autoComplete from "@tarekraafat/autocomplete.js";
import Main from "../Main";

export default class SearchAutoComplete {
	constructor() {
		const searchForm = document.querySelector(
			".content-sidebar form[role=search]"
		);

		if (searchForm) {
			/**
			 * @type {NodeListOf<HTMLInputElement>}
			 */
			const input = searchForm.querySelectorAll("input");

			if (input.length > 0) {
				input.item(0).addEventListener("keyup", (event) => {
					if (event.key === "Enter") {
						searchForm.submit();
					}
				});
				const inputID = input.item(0).id;

				const formData = new FormData();
				formData.append("action", "AutoComplete/getPostTitles");

				new autoComplete({
					selector: () => {
						return input.item(0)
					},
					data: {
						src: async (query) => {
							try {
								const source = await fetch(Main.Instance.url.ajax, {
									body: formData,
									method: "POST",
									credentials: "same-origin",
									headers: {
										Accept: "application/json",
									},
								});
								return source.json();
							} catch (error) {
								return error;
							}
						},
						cache: true,
					},
					resultsList: {
						class: "autocomplete-suggestions",
						element: (list, data) => {
							if (!data.results.length) {
								// Create "No Results" message element
								const message = document.createElement("div");
								// Add class to the created element
								message.setAttribute("class", "no_result");
								// Add message text content
								message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
								// Append message element to the results list
								list.prepend(message);
							}
						},
						noResults: true,
					},
					resultItem: {
						class: "autocomplete-suggestion",
					},
				});
			}
		}
	}
}
